import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { UpdateEquipmentModal } from './UpdateEquipmentModal';
import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { ImageFromServer } from '@/components/images/ImageFromServer';
import { CreateEquipment, Equipment } from '@/generated';
import { DefaultContainer } from '@/components/DefaultContainer';
import AddIcon from '@mui/icons-material/Add';
import { useEquipmentListQuery } from '@/hooks/query-hooks';
import { useDeleteEquipment } from '@/hooks/equipment-mutation.hooks';

export const EquipmentManager = () => {
  const [equipment, setEquipment] = useState<Equipment | CreateEquipment>();
  const { equipmentList } = useEquipmentListQuery();

  return (
    <DefaultContainer>
      <UpdateEquipmentModal setEquipment={setEquipment} equipment={equipment} onEquipmentUpdated={() => {}} />
      <Paper sx={{ my: 1, zIndex: 1, padding: 1, position: 'sticky', top: { xs: 60, sm: 65 } }}>
        <Grid sx={{ alignContent: 'center', alignItems: 'center' }} container gap={2} direction={'row'}>
          <Grid>
            <Tooltip title={'Create New Equipment'}>
              <IconButton
                onClick={() => {
                  setEquipment({ name: '', description: '' });
                }}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ my: 1 }}>
        <Grid sx={{ mt: 2 }} container>
          {equipmentList?.map((e) => (
            <EquipmentBox key={e.id} e={e} setEditEquipment={setEquipment} editEquipment={equipment} />
          ))}
        </Grid>
      </Box>
    </DefaultContainer>
  );
};

const EquipmentBox = (props: { e: Equipment; editEquipment: Equipment | CreateEquipment | undefined; setEditEquipment: (e: Equipment | CreateEquipment | undefined) => void }) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const wh = 60;

  return (
    <>
      <DeleteEquipmentDialog equipment={props.e} setOpen={setShowDeleteDialog} open={showDeleteDialog} />
      <Grid container size={12} onClick={() => props.setEditEquipment(props.e)}>
        <Grid size={2}>
          <Avatar sx={{ width: wh, height: wh, m: 1, backgroundColor: 'white' }}>
            <ImageFromServer sx={{ maxWidth: wh, maxHeight: wh }} thumbnail={true} alt="" id={props.e.imageId} />
          </Avatar>
        </Grid>
        <Grid size={2}>
          <Typography sx={{ m: 1 }} variant="h6">
            {props.e.name}
          </Typography>
        </Grid>
        <Grid size={6}>
          <Typography sx={{ m: 1 }}>{props.e.description}</Typography>
        </Grid>
        <Grid size={2}>
          <Button
            onClick={async (e) => {
              setShowDeleteDialog(true);
              e.preventDefault();
              e.stopPropagation();
            }}
            sx={{ m: 1 }}
          >
            Delete
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default function DeleteEquipmentDialog(props: { equipment: Equipment; open: boolean; setOpen: (open: boolean) => void }) {
  const { open, setOpen, equipment } = props;
  const deleteEquipmentMutation = useDeleteEquipment();

  return (
    <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{'Really delete?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">Really delete this Equipment?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={async () => {
            await deleteEquipmentMutation.mutateAsync(equipment.id);
            enqueueSnackbar('Equipment deleted!');
          }}
          color="primary"
          autoFocus
        >
          Yes
        </Button>
        <Button onClick={() => setOpen(false)} color="primary">
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}
